import React from "react";
import { Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";

import Icons from "components/icons";
import { Localize } from "components/service";


const CommentActionField = ({ comment, onEdit, onDelete }) => {
    const menu = (
        <Menu
            items={ [
                {
                    key: "1",
                    icon:
                        <span
                            role="button"
                            tabIndex={ 0 }
                            style={ { display: "flex", alignItems: "center", width: "100%" } }
                            onClick={ () => onEdit(comment.id) }
                            onKeyDown={ (event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    onEdit(comment.id);
                                }
                            } }
                        >
                            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
                        </span>
                },
                {
                    key: "2",
                    icon:
                        <span
                            role="button"
                            tabIndex={ 0 }
                            style={ { display: "flex", alignItems: "center", width: "100%" } }
                            onClick={ () => onDelete(comment.id) }
                            onKeyDown={ (event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    onDelete(comment.id);
                                }
                            } }
                        >
                            <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
                        </span>
                }
            ] }
        />
    );

    return (
        <Dropdown
            placement="bottomRight"
            overlay={ menu }
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default CommentActionField;
